'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LogInCaptcha = _react2['default'].createClass({
    displayName: 'LogInCaptcha',


    propTypes: {
        'recaptchaPublicKey': _react2['default'].PropTypes.string.isRequired,
        'tabIndex': _react2['default'].PropTypes.number
    },

    componentDidMount: function componentDidMount() {
        this.renderCaptcha();
    },

    captchaReload: function captchaReload(e) {
        e.preventDefault();
        grecaptcha.reset();
    },

    renderCaptcha: function renderCaptcha() {
        var container = document.querySelector(".g-recaptcha");
        grecaptcha.render(container, {
            "sitekey": this.props.recaptchaPublicKey,
            "theme": "custom"
        });
    },

    render: function render() {
        return _jsx('div', {
            id: 'recaptcha_widget',
            className: 'm-login--captcha'
        }, void 0, _jsx('div', {
            className: 'g-recaptcha',
            'data-sitekey': this.props.recaptchaPublicKey,
            'data-theme': 'custom'
        }, void 0));
    }
});

module.exports = LogInCaptcha;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-captcha.jsx
 ** module id = 757
 ** module chunks = 0
 **/